$(() => {
    const btn = $('.btn-totop');
    const animate_body = $('html, body');
    const animate_speed = 500;
    const trashold = 250;

    const toTop = () => {
        const scrollTop = $(window).scrollTop();
        if (scrollTop > trashold) {
            $(document).trigger('scrolled.Scroll');
        } else {
            $(document).trigger('topReached.Scroll');
        }
    }

    $(document)
        .on('topReached.Scroll', () => {
            btn.removeClass('scrolled');
            btn.fadeOut();
        })
        .on('scrolled.Scroll', () => {
            btn.addClass('scrolled');
            btn.css({display: 'flex'}).fadeIn();
        });

    btn.on('click', () => {
        animate_body.animate({scrollTop: 0}, animate_speed);
    });

    $(window).on('scroll.NavScroll', toTop);
});
